import { Injectable, signal } from '@angular/core';

export type DateFormat = 'dd/mm/yyyy' | 'mm/dd/yyyy';
export type DistanceUnit = 'km' | 'miles';

@Injectable({ providedIn: 'root' })
export class SettingsService {
  private readonly DATE_FMT_KEY  = 'ble_date_fmt';
  private readonly DIST_UNIT_KEY = 'ble_dist_unit';
  private readonly BEEP_KEY      = 'ble_beep';

  dateFormat   = signal<DateFormat>(this.restoreDateFormat());
  distanceUnit = signal<DistanceUnit>(this.restoreDistanceUnit());
  beepEnabled  = signal<boolean>(localStorage.getItem(this.BEEP_KEY) !== 'off');

  setFromLogin(dateFormat?: number, distanceUnits?: number): void {
    if (dateFormat !== undefined) {
      const fmt: DateFormat = dateFormat === 1 ? 'mm/dd/yyyy' : 'dd/mm/yyyy';
      this.dateFormat.set(fmt);
      localStorage.setItem(this.DATE_FMT_KEY, fmt);
    }
    if (distanceUnits !== undefined) {
      const unit: DistanceUnit = distanceUnits === 0 ? 'miles' : 'km';
      this.distanceUnit.set(unit);
      localStorage.setItem(this.DIST_UNIT_KEY, unit);
    }
  }

  setDateFormat(fmt: DateFormat): void {
    this.dateFormat.set(fmt);
    localStorage.setItem(this.DATE_FMT_KEY, fmt);
  }

  setDistanceUnit(unit: DistanceUnit): void {
    this.distanceUnit.set(unit);
    localStorage.setItem(this.DIST_UNIT_KEY, unit);
  }

  toggleBeep(): void {
    const next = !this.beepEnabled();
    this.beepEnabled.set(next);
    localStorage.setItem(this.BEEP_KEY, next ? 'on' : 'off');
  }

  private restoreDateFormat(): DateFormat {
    return localStorage.getItem(this.DATE_FMT_KEY) === 'mm/dd/yyyy' ? 'mm/dd/yyyy' : 'dd/mm/yyyy';
  }

  private restoreDistanceUnit(): DistanceUnit {
    return localStorage.getItem(this.DIST_UNIT_KEY) === 'miles' ? 'miles' : 'km';
  }
}
